export default {
  // GLOBAL
  'global#home': 'Home',
  'global#maps': 'Mappe',
  'global#works': 'Opere',
  'global#date_human': 'Do MMMM YYYY',
  'global#layout_error_title': 'Spiacenti, si è verificato un errore',
  'global#layout_error_description':
    "Prova a ricaricare la pagina tra qualche istante e se il problema persiste contatta l'amministratore della piattaforma.",
  'global#facet_empty_text': 'Nessun elemento disponibile',
  'global#facet_loading_text': 'Loading...',
  'global#itinerary': 'Percorsi',

  // READMORE
  'readmore#label': 'Mostra tutto',
  'readmore#more': 'Leggi tutto',
  'readmore#less': 'Leggi meno',

  // SEARCH
  // Page title
  'search#title_bibliographies': 'Bibliografia',
  'search#title_biographies': 'Vite antiche',
  'search#title_iconographies': 'Iconografie',
  'search#title_tools': 'Materiali e strumenti',
  'search#title_books': 'Biblioteca',
  'search#title_witnesses': 'Testimoni',
  'search#title_graffiti': 'Graffiti',
  'search#title_persons': 'Indice prosopografico',
  'search#title_voce_onomastica': 'Repertorio onomastico',
  'search#title_carica': 'Cariche, titoli e professioni',
  'search#title_termine': 'Repertorio lessicale',
  'search#title_formula_datazione': 'Formule di datazione',
  'search#title_luogo': 'Indice dei toponimi',
  'search#title_organizzazione': 'Entità politico-amministrative',
  // Total results
  'search#works_total': '<strong>{ total }</strong> Opere',
  'search#works_total_1': '<strong>{ total }</strong> Opera',
  'search#works_total_0': 'Nessuna Opera',
  'search#graffiti_total': '<strong>{ total }</strong> Graffiti',
  'search#graffiti_total_1': '<strong>{ total }</strong> Graffito',
  'search#graffiti_total_0': 'Nessun Graffito',
  'search#books_total': '<strong>{ total }</strong> Libri',
  'search#books_total_1': '<strong>{ total }</strong> Libro',
  'search#books_total_0': 'Nessun Libro',
  'search#witnesses_total': '<strong>{ total }</strong> Testimoni',
  'search#witnesses_total_1': '<strong>{ total }</strong> Testimone',
  'search#witnesses_total_0': 'Nessun Testimone',
  'search#bibliographies_total': '<strong>{ total }</strong> riferimenti bibliografici',
  'search#bibliographies_total_1': '<strong>{ total }</strong> riferimento bibliografico',
  'search#bibliographies_total_0': 'Nessun riferimento bibliografico',
  'search#biographies_total': '<strong>{ total }</strong> vite antiche',
  'search#biographies_total_1': '<strong>{ total }</strong> vita antica',
  'search#biographies_total_0': 'Nessuna vita antica',
  'search#iconographies_total': '<strong>{ total }</strong> iconografie',
  'search#iconographies_total_1': '<strong>{ total }</strong> icongrafia',
  'search#iconographies_total_0': 'Nessuna iconografia',
  'search#tools_total': '<strong>{ total }</strong> materiali e strumenti',
  'search#tools_total_1': '<strong>{ total }</strong> materiale e strumento',
  'search#tools_total_0': 'Nessun materiale e strumento',
  'search#persons_total': '<strong>{ total }</strong> voci',
  'search#persons_total_1': '<strong>{ total }</strong> voce',
  'search#persons_total_0': 'Nessuna voce',
  'search#voce_onomastica_total': '<strong>{ total }</strong> voci',
  'search#voce_onomastica_total_1': '<strong>{ total }</strong> voce',
  'search#voce_onomastica_total_0': 'Nessuna voce',
  'search#carica_total': '<strong>{ total }</strong> voci',
  'search#carica_total_1': '<strong>{ total }</strong> voce',
  'search#carica_total_0': 'Nessuna voce',
  'search#termine_total': '<strong>{ total }</strong> voci',
  'search#termine_total_1': '<strong>{ total }</strong> voce',
  'search#termine_total_0': 'Nessuna voce',
  'search#formula_datazione_total': '<strong>{ total }</strong> voci',
  'search#formula_datazione_total_1': '<strong>{ total }</strong> voce',
  'search#formula_datazione_total_0': 'Nessuna voce',
  'search#luogo_total': '<strong>{ total }</strong> voci',
  'search#luogo_total_1': '<strong>{ total }</strong> voce',
  'search#luogo_total_0': 'Nessuna voce',
  'search#organizzazione_total': '<strong>{ total }</strong> voci',
  'search#organizzazione_total_1': '<strong>{ total }</strong> voce',
  'search#organizzazione_total_0': 'Nessuna voce',
  // Facets
  'search#facets_title': 'Filtra i risultati',
  'search#placeholder_query': 'Cerca nei titoli',
  'search#placeholder_query-content': 'Cerca nelle opere contenute',
  'search#placeholder_authors': 'Cerca un autore',
  'search#placeholder_localita': 'Cerca regione, provincia, località',
  'search#placeholder_query-edizione': 'Cerca nell\'edizione',
  'search#placeholder_query_person': 'Cerca per nome',
  'search#placeholder_query_voce_onomastica': 'Cerca una voce onomastica',
  'search#placeholder_query_carica': 'Cerca una carica o titolo',
  'search#placeholder_query_termine': 'Cerca un termine',
  'search#placeholder_query_formula_datazione': 'Cerca una formula di datazione',
  'search#placeholder_query_luogo': 'Cerca un toponimo',
  'search#placeholder_query_organizzazione': 'Cerca un\'entità politico-amministrativa',
  'search#header_authors': 'Autori',
  'search#header_keywords': 'Keywords',
  'search#header_works': 'Opere',
  'search#header_libraries': 'Biblioteca',
  'search#header_cities': 'Città',
  'search#header_dates': 'Date',
  'search#header_genres': 'Genere',
  'search#header_language': 'Lingua',
  'search#header_map': 'Localizzazione',
  'search#header_years': 'Anni',
  'search#header_centuries': 'Datazione',
  'search#header_rilevamento': 'Fonte di rilevamento',
  'search#header_materiale': 'Materia del supporto',
  'search#header_tipologia': 'Tipologia del supporto',
  'search#header_tecnica': 'Tecnica di esecuzione',
  'search#header_sistema': 'Sistema di scrittura',
  'search#header_soggettario': 'Soggettario iconografico',
  'search#header_lingua': 'Lingua',
  'search#header_tipo': 'Tipo',
  'search#header_cert': 'Certezza della voce',
  'search#header_mista': 'Lingua mista',
  'search#header_tipo_termine': 'Tipo',
  'search#header_conservazione': 'Stato di conservazione',
  'search#header_autore': 'Autore',
  // Order
  'search#sort_title': 'Ordine',
  'search#sort_score': 'Ordine per pertinenza',
  'search#sort_asc': 'Ordine alfabetico (A→Z)',
  'search#sort_desc': 'Ordine alfabetico (Z→A)',
  'search#sort_freq_desc': 'Ordine per frequenza (dalla più attestata)',
  'search#sort_freq_asc': 'Ordine per frequenza (dalla meno attestata)',
  // Results
  'search#filters_title': 'Filtri attivi:',
  'search#fallback_text': 'La tua ricerca non ha dato risultati. Prova a cambiare i parametri oppure a resettare la ricerca cliccando sul pulsante sottostante.',
  'search#ko_text': 'Oops, abbiamo riscontrato un errore nella ricerca. Prova a cambiare i parametri oppure a resettare la ricerca cliccando sul pulsante sottostante.',
  'search#fallback_button': 'Resetta la ricerca',
  'search#ko_button': 'Resetta la ricerca',
  'search#resultsamount': 'Risultati per pagina',
  // Description
  'search#description_button': 'Info',
  'search#description_link': 'Ok, ho capito',

  // RESOURCE
  'resource#authors': 'di',
  'resource#date': 'pubblicato il',
  'resource#time_to_read': 'lettura di',
  'resource#metadata': 'Metadati',
  'resource#bibliography_graffito_biblio': 'Bibliografia',
  'resource#collection_graffito_links_interni': 'Collegamenti interni',
  'resource#collection_graffito_links_esterni': 'Collegamenti esterni',
  'resource#collection_graffito_text_persone': 'Persone',
  'resource#collection_graffito_text_nomi': 'Nomi',
  'resource#collection_graffito_text_ruoli': 'Ruoli',
  'resource#collection_graffito_text_luoghi': 'Luoghi',
  'resource#collection_graffito_links_voci_onomastiche': 'Voci onomastiche',
  'resource#collection_voce_onomastica_persone': 'Persone',
  'resource#collection_carica_persone': 'Persone',
  'resource#collection_graffito_links_cariche': 'Cariche e titoli',
  'resource#collection_graffito_links_termini': 'Repertorio lessicale',
  'resource#collection_voce_onomastica_graffiti': 'Graffiti collegati',
  'resource#collection_related-graffiti': 'Graffiti collegati',
  'resource#metadata_size': 'Dimensioni',
  'resource#bibliography': 'Bibliografia',
  'resource#title_book': 'Libro',
  'resource#title_toponym': 'Toponimi',
  'resource#title_iconography': 'Iconografie',
  'resource#title_keyword': 'Termini',
  'resource#title_tool': 'Materiali e Strumenti',
  'resource#title_witness': 'Testimoni',
  'resource#title_biography': 'Vite antiche',
  'resource#title_graffito': 'Graffito',
  'resource#title_persona': 'Persona',
  'resource#title_voce_onomastica': 'Voce onomastica',
  'resource#title_carica': 'Carica',
  'resource#title_termine': 'Termine',
  'resource#title_luogo': 'Luogo',
  'resource#title_organizzazione': 'Entità politico-amministrativa',
  
  // ADVANCED SEARCH
  'advancedsearch#submit': 'Cerca',
  'advancedsearch#reset': 'Pulisci i campi',
  'advancedsearch#works_total': '<strong>{ total }</strong> risultati',
  'advancedsearch#works_total_1': '<strong>{ total }</strong> risultato',
  'advancedsearch#works_total_0': 'Nessun risultato',
  'advancedsearch#results_number': 'Risultati per pagina',
  'advancedsearch#fulltext_text': 'Cerca nel portale (in tutti i campi)',
  'advancedsearch#label_title': 'Titolo',
  'advancedsearch#title': 'Ricerca avanzata',
  'advancedsearch#title_results': 'Risultati',

  // TABS GRAFFITO
  'tabs#graffito_localization': 'Localizzazione',
  'tabs#graffito_date': 'Datazione',
  'tabs#graffito_description': 'Descrizione Esterna',
  'tabs#graffito_text': 'Testo',
  'tabs#graffito_conservation': 'Conservazione',
  'tabs#graffito_biblio': 'Bibliografia',
  'tabs#graffito_observation': 'Osservazioni',
  'tabs#graffito_links': 'Contenuti collegati',
};